import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManagementStratgeyRoutingModule } from './management-stratgey-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MaterialModule } from 'src/app/material.module';
import { ManagementStraPageComponent } from './components/management-stra-page/management-stra-page.component';
import { AdminManagementStraComponent } from './components/admin-management-stra/admin-management-stra.component';


@NgModule({
  declarations: [ ManagementStraPageComponent, AdminManagementStraComponent],
  imports: [
    CommonModule,
    ManagementStratgeyRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
  ]
})
export class ManagementStratgeyModule { }
